import { DELAY } from 'src/app/core/utils/constants';
import { PETICIONES } from './../utils/constants';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Xmlfields } from '../../core/entities/xmlfields.model';
import { delay } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class XmlfieldsService {
    readonly BASE: any = PETICIONES.xmlfields;

    constructor(private http: HttpClient) { }

    /**
   * @description
   * Obtiene todos los xmlfields
   */
  public findAll(): Observable<any> {
    return this.http.get(this.BASE.findAll).pipe(delay(DELAY));
  }

  /**
   * @description
   * Obtiene un xmlfields por su id
   */
  public findById(id: number): Observable<any> {
    let idxmlfields: string = (id !== undefined && id !== null ? id + "" : "");
    return this.http.get(this.BASE.findById + "/" + idxmlfields).pipe(delay(DELAY));
  }

  /**
   * @description
   * Obtiene una lista de xmlfields por su id xmldef
   */
  public findByXmldefId(id: number): Observable<any> {
    let idxmlfields: string = (id !== undefined && id !== null ? id + "" : "");
    return this.http.get(this.BASE.findByXmldefId + "/" + idxmlfields).pipe(delay(DELAY));
  }

  /**
   * @description
   * Guarda un xmlfields en la base de datos
   */
  public postXmlfield(xmlfields: Xmlfields): Observable<any> {
    const json = JSON.stringify(xmlfields);
    const headers = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
    return this.http.post(this.BASE.postXmlfields, json, {headers: headers}).pipe(delay(DELAY));
  }

  /**
   * @description
   * Borra un xmlfields en la base de datos
   */
  public deleteXmlfield(xmlfields: Xmlfields): Observable<any> {
    let idxmlfields: string = (xmlfields.id !== undefined && xmlfields.id !== null ? xmlfields.id + "" : "");
    return this.http.get(this.BASE.deleteXmlfields + "/" + idxmlfields).pipe(delay(DELAY));
  }


}